import jwtDecode from 'jwt-decode';
import { googleAuthContext } from '../../utils/social/googleAuthContext';
export default (function (callback) {
  googleAuthContext.setCallback(function (response) {
    var idToken = response.credential;

    try {
      var _jwtDecode = jwtDecode(idToken),
          email = _jwtDecode.email,
          name = _jwtDecode.name;

      callback({
        token: idToken,
        email: email,
        name: name
      }); // eslint-disable-next-line no-empty
    } catch (error) {}
  });
  googleAuthContext.mountGoogleButton();
  googleAuthContext.fireFakeClick();
});